import { TextField, Avatar } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";

const AddDatosGenerales = ({ onFormGeneralDataChange, perfildata }) => {
    const [formData, setFormData] = useState(perfildata || {
        DrName: "",
        DrSubName1: "",
        DrSubName2: "",
        Charge: "",
        Phone: "",
        imageUrl: null,
        Price: "",
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData({ ...formData, imageUrl: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAvatarClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const fileInputRef = useRef(null);

    useEffect(() => {
        onFormGeneralDataChange(formData);
    }, [formData, onFormGeneralDataChange]);
    return (
        <div className="p-4">
            <div className="flex flex-col items-center mb-4">
                <Avatar
                    src={formData.imageUrl || "https://via.placeholder.com/150"}
                    alt="Avatar"
                    sx={{ width: 100, height: 100, cursor: "pointer" }}
                    onClick={handleAvatarClick}
                />
                <input
                    type="file"
                    name="imagen"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    className="hidden"
                />
            </div>
            <div className="space-y-4">
                <TextField
                    label="Apellido Paterno del Doctor"
                    name="DrSubName1"
                    fullWidth
                    onChange={handleChange}
                    value={formData.DrSubName1}
                />
                <TextField
                    label="Apellido Materno del Doctor"
                    name="DrSubName2"
                    fullWidth
                    onChange={handleChange}
                    value={formData.DrSubName2}
                />
                <TextField
                    label="Nombre(s) del Doctor"
                    name="DrName"
                    fullWidth
                    onChange={handleChange}
                    value={formData.DrName}
                />
                <TextField
                    label="Cargo (Ej. Médico Cirujano)"
                    name="Charge"
                    fullWidth
                    onChange={handleChange}
                    value={formData.Charge}
                />
                <TextField
                    label="Teléfono"
                    name="Phone"
                    fullWidth
                    onChange={handleChange}
                    value={formData.Phone}
                />

                <TextField
                    label="Precio $"
                    name="Price"
                    type="number"
                    fullWidth
                    onChange={handleChange}
                    value={formData.Price}
                />
            </div>
        </div>
    );
};

export default AddDatosGenerales;